"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DialogContentWrapper {
    constructor(
    // private dialogManager: DialogManager,
    dialog, buttons, onCancel, closeButton) {
        this.dialog = dialog;
        this.buttons = buttons;
        this.onCancel = onCancel;
        this.closeButton = closeButton;
    }
    get element() {
        return this.dialog.element;
    }
    getCloseButton() {
        return this.closeButton || null;
    }
    getButtons() {
        return this.buttons;
    }
    async isDirty() {
        if (this.dialog.isDirty) {
            return this.dialog.isDirty();
        }
        return false;
    }
    render() {
        return this.dialog.render?.();
    }
    init() {
        return this.dialog.init?.();
    }
    cancelled() {
        this.onCancel();
    }
}
exports.default = DialogContentWrapper;
//# sourceMappingURL=DialogContentWrapper.js.map